import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Spinner/Spinner';

const Poster = ({ room, isRoomLoading }) => {
    return isRoomLoading ? <Spinner /> :
        <div className="grid-y medium-grid-frame tx-kiosk__poster">
            <img src={room.posterUrl} alt="Kiosk Poster Goes Here" />
        </div>;
};

export default Poster;

Poster.propTypes = {
    isRoomLoading: PropTypes.bool,
    room: PropTypes.any,
};

Poster.defaultProps = {
    isRoomLoading: true,
    room: {},
};



// WEBPACK FOOTER //
// ./src/components/Poster/Poster.jsx